/* eslint-disable no-useless-catch */

/**
 * System service
 */

// Models
import { IDataUpdateStatusServiceUser, IParamGetList } from 'models/UserRequest';

// Constants
import { HTTP_METHOD } from 'utils/constants';

// Configs
import AdminService from 'configs/api/adminService';

const ENDPOINTS = {
  API_GET_SYSTEM_APPLICATION_SETTING: ['/services/search', HTTP_METHOD.GET],
  API_GET_SYSTEM_APPLICATION_SETTING_CHECK: ['/service-users/requested', HTTP_METHOD.GET],
  API_EXPORT_SYSTEM_APPLICATION_SETTING_CHECK: ['/service-users/requested/export', HTTP_METHOD.GET],
  API_UPDATE_BULK_SYSTEM_APPLICATION_SETTING_CHECK: ['/service-users/update', HTTP_METHOD.PUT],
};

class SystemService extends AdminService {
  constructor() {
    super();
  }

  async getSystemApplicationSetting(params?: IParamGetList) {
    try {
      const results = await this.request(
        ENDPOINTS.API_GET_SYSTEM_APPLICATION_SETTING,
        [],
        null,
        params
      );
      return results?.data?.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async getSystemApplicationSettingCheck(params: IParamGetList) {
    try {
      const results = await this.request(
        ENDPOINTS.API_GET_SYSTEM_APPLICATION_SETTING_CHECK,
        [],
        null,
        params
      );
      return results?.data?.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async exportSystemApplicationSettingCheck(params: IParamGetList) {
    try {
      const results = await this.request(
        ENDPOINTS.API_EXPORT_SYSTEM_APPLICATION_SETTING_CHECK,
        [],
        { responseType: 'blob' },
        params
      );
      return results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }

  async updateBulkServiceUserStatus(data: IDataUpdateStatusServiceUser) {
    try {
      const results = await this.request(
        ENDPOINTS.API_UPDATE_BULK_SYSTEM_APPLICATION_SETTING_CHECK,
        [],
        data
      );
      return results?.data?.results;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  }
}

export default new SystemService();
